/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import config from "../../app/config";
import { RCLContext } from "../../components/RCL/RCLProvider";
import { StarBalance } from "../../components/Star/Balance";
import { StarStats } from "../../components/Star/Balance/StarStats";
import { RCL } from "../../components/RCL";
import { Loader } from "../../components/Loader";
import { StringResources } from "../../components/StringResources";
import { useOktaAuth } from "@okta/okta-react";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("../MyLoyaltyProgram/MyLoyaltyProgramVwq.module.scss");
  } else {
    styles = await import("../MyLoyaltyProgram/MyLoyaltyProgram.module.scss");
  }
})();

const StarCardContainer = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [accessToken, setAccessToken] = useState();
  const [userInfo, setUserInfo] = useState(null);
  const { locale } = useContext(RCLContext);
  const [starCardInfo, setStarCardInfo] = useState(null);
  const [globalId, setGlobalId] = useState();
  const [totalPtnsEarned, setTotalPtnsEarned] = useState();
  const [totalPtnsUsed, setTotalPtnsUsed] = useState();
  const [starCashBal, setStarCashBal] = useState(0);
  const [isActivated, setIsActivated] = useState();
  const [isExpiring, setIsExpiring] = useState();
  const [ewalletLink, setEwalletLink] = useState();
  const [externalCardHolderId, setExternalCardHolderId] = useState();
  const [redemptionRules, setRedemptionRules] = useState();
  const [provinceList, setProvinceList] = useState(null);
  const [isValidAgencyNumber, setIsValidAgencyNumber] = useState();

  const getProfileInfo = async (token) => {
    fetch(`${config.resourceServer.agentApiUrl}/account/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.json();
      })
      .then((data) => {
        getAgency(data.agencyNumber);
      });
  };

  const getAgency = async (agencyNum) => {
    fetch(`${config.resourceServer.agentApiUrl}/opn/agency/${agencyNum}`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.json();
      })
      .then((data) => {
        if(data) {
          setIsValidAgencyNumber(true);
        }else {
          setIsValidAgencyNumber(false);
        } 
      })
      .catch((err) => {
        setIsValidAgencyNumber(false);
      });
  };
  
  const getStarCardInfo = async (token) => {
    await fetch(`${config.resourceServer.agentApiUrl}/loyalty`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.json();
      })
      .then((data) => {
        setStarCardInfo(data);
        setGlobalId(data.starAgentInfo?.enterpriseReferenceKey);        
        setTotalPtnsEarned(data.starCard?.totalPtnsEarned);     
        setTotalPtnsUsed(data.starCard?.totalPtnsUsed);
        setExternalCardHolderId(data.starAgentInfo?.externalCardHolderId);
        setStarCashBal(data.starCard?.starCashBal??0);
        setIsActivated(data.starCard?.isActivated);
        setIsExpiring(data.starCard?.isExpiring);
        setEwalletLink(data.starCard?.ewalletLink);
        const provinceData = data.provinces;
        setProvinceList(provinceData);
      });
  };

  const updateStarCardInfo = async (callback) => {
    await getStarCardInfo(accessToken);

    if (typeof callback === "function") {
      callback();
    }
  };

  const getRedemptionRules = async (token) => {
    await fetch(`${config.resourceServer.agentApiUrl}/loyalty/card/redemption`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.json();
      })
      .then((data) => {
        setRedemptionRules(data);
      });
  }

  useEffect(() => {
    
     if (authState && authState.isAuthenticated) {
        oktaAuth.getUser().then((info) => {
        setUserInfo(info);
        setAccessToken(oktaAuth.getAccessToken());
        getProfileInfo(oktaAuth.getAccessToken());
        getStarCardInfo(oktaAuth.getAccessToken());
        getRedemptionRules(oktaAuth.getAccessToken());
      });
    }
  }, [authState, oktaAuth, locale]);

  const labels = {
    starProgram: RCL({ searchKey: "star_program" }),
    bookingActivity: RCL({ searchKey: "star_activity" }),
    howPointsAreAwarded: RCL({ searchKey: "howPointsAreAwarded" }),
    flightSegments: RCL({ searchKey: "flightSegments" }),
    hotelRooms: RCL({ searchKey: "hotelRooms" }),
    carRentals: RCL({ searchKey: "carRentals" }),
    excursions: RCL({ searchKey: "excursions" }),
    insurancePlans: RCL({ searchKey: "insurancePlans" }),
    bookings: RCL({ searchKey: "bookings" }),
    oneMonth: RCL({ searchKey: "1month" }),
    sixMonths: RCL({ searchKey: "6months" }),
    twelveMonths: RCL({ searchKey: "12months" }),
    currentPointsBalance: RCL({ searchKey: "currentPointsBalance" }),
    minimumRedemption1: RCL({ searchKey: "minimumRedemption" }),
    yourPoints: RCL({ searchKey: "yourPoints" }),
    note: RCL({ searchKey: "notes-ap" }),
    renewYourSTARCard: RCL({ searchKey: "renewYourSTARCard" }),
    loadYourSTARCard: RCL({ searchKey: "loadYourSTARCard" }),
    rateOf: RCL({ searchKey: "rateof" }),
    pointMinimum: RCL({ searchKey: "pointminimum" }),
    maxPointsValue: RCL({ searchKey: "maxPointsValue" }),
    enterPointsToRedeem: RCL({ searchKey: "enterPointsToRedeem" }),
    starLoyaltyProgram: RCL({ searchKey: "starLoyaltyProgram" }),
    starCardNumber: RCL({ searchKey: "starCardNumber" }),
    cashValue: RCL({ searchKey: "cashValue" }),
    loadCash: RCL({ searchKey: "loadCash" }),
    backToBalance: RCL({ searchKey: "backToBalance" }),
    modalClose: RCL({ searchKey: "modal-close" }),
    myPointsTransactions: RCL({ searchKey: "myPointsTransactions" }),
    platinumClub: RCL({ searchKey: "platinumclub" }),
    month: RCL({ searchKey: "month" }),
    minimumRedemption: RCL({ searchKey: "minimumredemption" }),
    pointsOr: RCL({ searchKey: "pointsor" }),
    btnYes: RCL({ searchKey: "yes" }),
    btnNo: RCL({ searchKey: "no" }),
    renewalConfirmation: RCL({ searchKey: "loyalty_card_renewal_confirmation" }), 
    redeemTotalLimitationMessage: RCL({ searchKey: "daily-redeem-limit-reached" }),
    redeemTimesLimitationMessage: RCL({ searchKey: "daily-redeem-times-limit-reached" }),
    maximumRedemptionMessgae: RCL({ searchKey: "maximum-redemption-message" }),
    okStarLoadSuccessful: RCL({ searchKey: "OK_StarLoadSuccessful" })
  };

  if (!userInfo && starCardInfo && isActivated !== undefined) {
    return (
      <div className="star-balance__loader">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {styles && 
        (<div className={config.isWestJetMode ? styles.myLoyaltyProgramVwq: ""}>
          {starCardInfo && starCardInfo.isStarRegistered && redemptionRules && (
            <>
              <div className="star-balance__main-container">
                <StarStats
                  starRewardId={starCardInfo.starAgentInfo?.computedEnterpriseReferenceKey}
                  labels={{
                    bookingActivity:  RCL({ searchKey: "star_activity" }),
                    howPointsAreAwarded: labels.howPointsAreAwarded,
                    flightSegments: labels.flightSegments,
                    hotelRooms: labels.hotelRooms,
                    carRentals: labels.carRentals,
                    excursions: labels.excursions,
                    insurancePlans: labels.insurancePlans,
                    bookings: labels.bookings,
                  }}
                  filters={[
                    {
                      label: labels.oneMonth,
                      value: "-1",
                    },
                    {
                      label: labels.sixMonths,
                      value: "-6",
                    },
                    {
                      label: labels.twelveMonths,
                      value: "-12",
                    },
                  ]}
                />
                <StarBalance
                  refreshData={updateStarCardInfo}
                  {...{
                    initialData: totalPtnsEarned - totalPtnsUsed,
                    currentDateRedeemTotal: starCardInfo.starCard.currentDateRedeemTotal,
                    currentDateRedeemCount: starCardInfo.starCard.currentDateRedeemCount,
                    globalCanLoadCard: RCL({
                      searchKey: "globalCanLoadCard",
                    }),
                    config: {
                      locale: locale,
                      labels: {
                        currentPointsBalance: labels.currentPointsBalance,
                        minimumRedemption: labels.minimumRedemption1,
                        yourPoints: labels.yourPoints,
                        note: labels.note,
                        balanceNote: `${labels.minimumRedemption} {{minPoints}} ${labels.pointsOr} {{minPointsValue}}.`,
                        btnYes:labels.btnYes,
                        btnNo:labels.btnNo,
                        renewalConfirmation:labels.renewalConfirmation,
                      },
                      footer: {
                        loadStar: {
                          initialData: {
                            AgentGlobalId: globalId,
                            MinPntsRedeem: redemptionRules.minPntsRedeem,
                            MaxPntsRedeem: redemptionRules.maxPntsRedeem,
                            PointRate: redemptionRules.pointRate,
                          },
                          starAgentInfo: starCardInfo.starAgentInfo,
                          isValidAgencyNumber: isValidAgencyNumber,
                          STARData: {
                            ExternalCardHolderId: externalCardHolderId,
                            TotalPtnsEarned: totalPtnsEarned,
                            TotalPtnsUsed: totalPtnsUsed,
                            STARCashBal: starCashBal,
                            IsActivated: isActivated,
                            IsExpiring: isExpiring,
                            EwalletLink: ewalletLink,
                          },
                          provinces: provinceList,
                          urlPost: `${config.resourceServer.agentApiUrl}/loyalty/Card/Redemption`,
                          token: accessToken,
                          labels: {
                            renewYourSTARCard: labels.renewYourSTARCard,
                            loadYourSTARCard: labels.loadYourSTARCard,
                            redemptionRules: `${labels.rateOf} {{rate}} ${labels.pointMinimum} {{minPoints}} ${labels.pointsOr} {{minPointsValue}}. ${labels.maxPointsValue} {{maxPointsValue}}.`,
                            enterPointsToRedeem: labels.enterPointsToRedeem,
                            starLoyaltyProgram: labels.starLoyaltyProgram,
                            STARCardNumber: labels.starCardNumber,
                            cashValue: labels.cashValue,
                            loadCash: labels.loadCash,
                            backToBalance: labels.backToBalance,
                            close: labels.modalClose,
                            loadStarCardImageUrl: StringResources({searchKey: "load-star-card-image"}),
                            redeemTotalLimitationMessage:labels.redeemTotalLimitationMessage,
                            redeemTimesLimitationMessage:labels.redeemTimesLimitationMessage,
                            maximumRedemptionMessgae:labels.maximumRedemptionMessgae,
                            okStarLoadSuccessful:labels.okStarLoadSuccessful
                          },
                          returnUrl: `/${locale}/star-program-swg`,
                        },
                        myPointsTransactions: {
                          labels: {
                            myPointsTransactions: labels.myPointsTransactions,
                          },
                          url: `/${locale}/transactions`,
                        },
                      },
                    },
                  }}
                />
              </div>
            </>
          )}
        </div>)}
    </>
  );
};

export default StarCardContainer;
export { StarCardContainer };
